module.exports = __webpack_public_path__ + "img/81_19.505f0b9a.png";